namespace RioERP.Orders {
    export namespace OrderShippingService {
        export const baseUrl = 'Orders/OrderShipping';

        export declare function Create(request: Serenity.SaveRequest<OrderShippingRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<OrderShippingRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OrderShippingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve2(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OrderShippingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<OrderShippingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function AssignTrackingNumbers(request: string[], onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function MarkAsReturned(request: string[], onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function MarkAsDelivered(request: string[], onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function AssignTrackingDelhivery(request: string[], onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function AssignTrackingDTDC(request: string[], onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Orders/OrderShipping/Create",
            Update = "Orders/OrderShipping/Update",
            Delete = "Orders/OrderShipping/Delete",
            Retrieve = "Orders/OrderShipping/Retrieve",
            Retrieve2 = "Orders/OrderShipping/Retrieve2",
            List = "Orders/OrderShipping/List",
            AssignTrackingNumbers = "Orders/OrderShipping/AssignTrackingNumbers",
            MarkAsReturned = "Orders/OrderShipping/MarkAsReturned",
            MarkAsDelivered = "Orders/OrderShipping/MarkAsDelivered",
            AssignTrackingDelhivery = "Orders/OrderShipping/AssignTrackingDelhivery",
            AssignTrackingDTDC = "Orders/OrderShipping/AssignTrackingDTDC"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'Retrieve2', 
            'List', 
            'AssignTrackingNumbers', 
            'MarkAsReturned', 
            'MarkAsDelivered', 
            'AssignTrackingDelhivery', 
            'AssignTrackingDTDC'
        ].forEach(x => {
            (<any>OrderShippingService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
